// Setup

// TODO: Directly use the PaymentStore, GuestPaymentStore, etc

// Remove from session storage
const sessionItems = [
    "hoapay_guestPayment_homeowner",
    "hoapay_guestPayment_payment",
    "hoapay_guestPayment_paymentRequest",
    "hoapay_guestPayment_property",
    "hoapay_guestPayment_routingNumber",
    "hoapay_guestPayment_viewedTc",
    "hoapay_guestPayment_paymentDate"
];

if(typeof sessionStorage !== "undefined"){
    sessionItems.forEach(key  => {
        sessionStorage.removeItem(key);
    })
}

// Remove from local storage
const localItems = [
    "paymentMethod_registered",
    "paymentDate_registered",
    "paymentRequest_registered",
    "paymentDues_registered",
    "paymentProperty_registered"
];

if(typeof localStorage !== "undefined"){
    localItems.forEach(key => {
        localStorage.removeItem(key);
    })
}
